/**
 * The brand's wait: the N draws its outline on a white tile, fills in with a
 * soft ping, and a light runs around the tile's edge. CSS keyframes only
 * (`globals.css` `--animate-loader-*`) so no JS animation library sits on the
 * first-paint path — this is the Suspense/auth fallback for every route. It
 * fades in after a beat, so a fast load never flashes it.
 */
export function BrandLoader() {
  return (
    <div
      data-testid="loading-spinner"
      role="status"
      className="relative flex size-20 animate-loader-enter items-center justify-center motion-reduce:animate-none"
    >
      <span className="sr-only">Loading</span>
      <span
        aria-hidden
        className="absolute inset-0 animate-loader-halo rounded-panel bg-primary/15 motion-reduce:hidden"
      />
      <svg
        aria-hidden
        viewBox="0 0 92 92"
        fill="none"
        className="absolute -inset-1.5 size-23 overflow-visible text-primary"
      >
        <rect x="1" y="1" width="90" height="90" rx="25" stroke="currentColor" strokeOpacity="0.1" strokeWidth="1.5" />
        <rect
          data-slot="loader-orbit"
          x="1"
          y="1"
          width="90"
          height="90"
          rx="25"
          pathLength={1}
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDasharray="0.16 0.84"
          className="animate-loader-orbit motion-reduce:hidden"
        />
      </svg>
      <div className="relative flex size-20 items-center justify-center rounded-panel bg-card shadow-card">
        <svg aria-hidden viewBox="0 0 156 185" className="size-9 overflow-visible text-primary">
          <path
            data-slot="loader-mark"
            d="M0 185.25V0H43.535L116.611 127.849V0H156V185.25H111.947L39.389 61.837V185.25H0Z"
            pathLength={1}
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinejoin="round"
            strokeDasharray="1"
            className="animate-loader-draw motion-reduce:animate-none"
          />
        </svg>
      </div>
    </div>
  )
}
